import { Reveal } from "./Reveal";

export const Scalability = () => {
  return (
    <section className="bg-ivory py-24 sm:py-36" data-testid="scalability">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20">
        <div>
          <Reveal>
            <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-6">CAPITOLO 09 — SCALABILITÀ</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.03] tracking-tight">
              La tua collezione può evolvere insieme al tuo brand.
            </h2>
          </Reveal>
        </div>
        <div>
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-base sm:text-lg text-ink/70 leading-relaxed max-w-xl">
              Non devi costruire oggi il catalogo che venderai domani. Con My Brand Online puoi selezionare i prodotti
              più adatti al tuo pubblico, aggiornare la tua proposta e aggiungere nuove collezioni nel tempo.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
              {["Scegli.", "Pubblica.", "Vendi.", "Aggiorna."].map((t) => (
                <span key={t} className="font-display italic text-2xl sm:text-3xl text-ink">{t}</span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-12 border-t hairline pt-8 space-y-1">
              <p className="font-display text-2xl sm:text-3xl text-ink">Più libertà nel costruire la tua offerta.</p>
              <p className="font-display text-2xl sm:text-3xl text-goldtan">Meno vincoli nella gestione della merce.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
